/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsEDRIntuneDeploymentCount
 */
export interface JumboStructsEDRIntuneDeploymentCount {
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRIntuneDeploymentCount
     */
    deployedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRIntuneDeploymentCount
     */
    notDeployedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRIntuneDeploymentCount
     */
    totalCount?: number;
}

/**
 * Check if a given object implements the JumboStructsEDRIntuneDeploymentCount interface.
 */
export function instanceOfJumboStructsEDRIntuneDeploymentCount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsEDRIntuneDeploymentCountFromJSON(json: any): JumboStructsEDRIntuneDeploymentCount {
    return JumboStructsEDRIntuneDeploymentCountFromJSONTyped(json, false);
}

export function JumboStructsEDRIntuneDeploymentCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsEDRIntuneDeploymentCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deployedCount': !exists(json, 'deployedCount') ? undefined : json['deployedCount'],
        'notDeployedCount': !exists(json, 'notDeployedCount') ? undefined : json['notDeployedCount'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
    };
}

export function JumboStructsEDRIntuneDeploymentCountToJSON(value?: JumboStructsEDRIntuneDeploymentCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deployedCount': value.deployedCount,
        'notDeployedCount': value.notDeployedCount,
        'totalCount': value.totalCount,
    };
}

